import { FC } from 'react'
import { useAuth } from '../../lib/auth'

type Props = {
  productLineId: string
}

export const CanRender: FC<Props> = ({ children, productLineId }) => {
  const { user } = useAuth()

  if (user?.productLineId === productLineId) return <>{children}</>

  return null
}
